import {useState} from "react";
import {addApi, getSizesApi} from "@/features/profile/api/waitListApi";
import {useWaitListStore} from "@/Stores/Site/Profile";
import {useNotSizeStore} from "@/Stores/Site/Product";

export function useAddToWaitList() {
    const [loading, setLoading] = useState(false);
    const [loadingId, setLoadingId] = useState(null);

    const openAddWaitListModal = useWaitListStore(state => state.openAddWaitListModal);
    const openModalNotSize = useNotSizeStore(state => state.openModalNotSize);

    const addToWaitList = async ({productId, size}) => {
        if (loading) return;
        // if (loadingId === productId) return;

        try {
            setLoading(true);
            setLoadingId(productId);

            if (size) {
                return handleAdd({productId, size});
            }

            const response = await getSizesApi(productId);
            const {success} = response.data;
            const {status = false, data = []} = success;

            if (!status) {
                return handleError();
            }

            if (!data.length) {
                return handleAdd({productId});
            }

            openModalNotSize({
                productId,
                productData: data
            });

        } catch (e) {
            handleError();
        } finally {
            setLoading(false);
            setLoadingId(productId);
        }
    };

    const handleAdd = async ({productId, size = ''}) => {
        try {
            const response = await addApi({
                id_product: productId,
                size,
            });

            const {success} = response.data;
            const {status = false, data = [], errors = []} = success;

            if (!status) {
                openAddWaitListModal({
                    title: errors.title,
                    message: errors.errorMessage?.[0],
                });
                return;
            }

            openAddWaitListModal({
                title: data.title,
                message: data.message,
            });
        } catch (e) {
            handleError();
        }
    };

    const handleError = ({
                             title = 'Внимание',
                             message = 'Не удалось добавить украшение в лист ожидания!',
                         } = {}) => {
        openAddWaitListModal({
            title,
            message,
        });
    };

    return {addToWaitList, loading, loadingId};
}
